import { saveAs } from "file-saver";
import docSupEquipmentDoc from 'assets/documents/Υπόδειγμα Λίστα Εξοπλισμού.xlsx';
import docSupCertEquipmentDoc from 'assets/documents/Λίστα Εξοπλισμού (DELETE) .xlsx';
import { InfoMessage } from 'components';

export const content = () =>
  [
   {
      label:
      (
        <span>
          <span>
            <b>Αρχείο Ανανέωσης Εξοπλισμού</b><span>&nbsp;</span><text style={{fontWeight:"normal", fontSize:"11px"}}>(Κατεβάστε το υπόδειγμα <a style={{textDecoration: "underline"}} onClick={()=>saveAs(docSupEquipmentDoc, "Λίστα Εξοπλισμού")}>εδώ</a>)</text>
          </span>
        </span>
      ),
      fileCode: 'fileForUpdate',
      id: 'fileForUpdate',
      fileLimit: 10,
      required: false,
      fileAccepts: ['.xls', '.xlsx' ,'.xlsm'],
      descriptionUpload: 'Κάντε κλικ για ανέβασμα ή σύρετε και αποθέστε αρχείo',
    },
    {
      label:
        <div style={{display:'flex', marginRight:'5px'}}>
        <b>Αρχείο Διαγραφής Εξοπλισμού</b><span>&nbsp;</span><text style={{fontWeight:"normal", fontSize:"11px"}}>(Κατεβάστε το υπόδειγμα <a style={{textDecoration: "underline"}} onClick={()=>saveAs(docSupCertEquipmentDoc, "Λίστα Εξοπλισμού(DELETE)")}>εδώ</a>)</text>        <InfoMessage
        />
      </div>,
      fileCode: 'fileForDeletion',
      id: 'fileForDeletion',
      fileLimit: 10,
      multiple: true,
      required: false,
      fileAccepts : ['.xls', '.xlsx' ,'.xlsm'],
      descriptionUpload: 'Κάντε κλικ για ανέβασμα ή σύρετε και αποθέστε αρχείo',
    },
    
  ].filter(item => item);
